<div class="col-lg-9 col-md-11 col-sm-12">
  <div class="info-title">{{ 'createPoint.title.content' | translate }}</div>
  <section class="mt-4">
    <div style="display: flex; justify-content: space-between; margin-bottom: 10px; align-items: center">
      <h1 style="color: #24344b; font-weight: 600; font-size: 16px; margin-bottom: 0px"></h1>
      <a style="color: #12ceff; font-weight: 600; font-size: 16px; text-transform: uppercase; cursor: pointer"
        (click)="onShowAll()"><i class="fad fa-arrows-v"></i>&nbsp;{{
        !showAllAccordion ? ('Tout ouvrir' | translate) : ('Tout fermer' | translate)
        }}</a>
    </div>
    <p-accordion [multiple]="true">
      <p-accordionTab (click)="onClick('Motivation', 0)" [(selected)]="activeState[0]">
        <ng-template pTemplate="header">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              <h2 class="accordion-header-title" pTooltip="Motivation">
                Motivation
                <i class="icon-checkGreen green-icon"
                  *ngIf="contenuStaticRTFFilesPresents && contenuStaticRTFFilesPresents.motivation"></i>
              </h2>
            </div>
            <div class="accordion-icon">
              <i *ngIf="pointId" (click)="openFullScreen($event, 'Motivation')"
                class="icon-fullscreen blue-icon middle-icon me-3"></i>
              <i pTooltip="Actualiser" tooltipPosition="bottom" (click)="reloadRTF($event, 'Motivation', 0)"
                class="far fa-redo-alt blue-icon middle-icon">
              </i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <super-richedit [lang]="languageRichEdit" (click)="handleClick($event)" #document_editor_motivation
            (getRtf)="getMotivation($event)" (save)="submitAContent($event, 'Motivation')" [mergeFields]="fusions"
            [showHidde]="true"
            [font]="globalElements?.configApp?.delibConfig?.defaultMiseEnFormeParams"></super-richedit>
        </ng-template>
      </p-accordionTab>
      <p-accordionTab (click)="onClick('Decision', 1)" [(selected)]="activeState[1]">
        <ng-template pTemplate="header">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              <h2 class="accordion-header-title" pTooltip="Décision">
                Décision
                <i class="icon-checkGreen green-icon"
                  *ngIf="contenuStaticRTFFilesPresents && contenuStaticRTFFilesPresents?.decision"></i>
              </h2>
            </div>
            <div class="accordion-icon">
              <i *ngIf="pointId" (click)="openFullScreen($event, 'Decision')"
                class="icon-fullscreen blue-icon middle-icon me-3"></i>
              <i pTooltip="Actualiser" tooltipPosition="bottom" (click)="reloadRTF($event, 'Decision', 1)"
                class="far fa-redo-alt blue-icon middle-icon">
              </i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <super-richedit [lang]="languageRichEdit" *ngIf="globalElements.isLoaded()" (click)="handleClick($event)"
            #document_editor_decision (getRtf)="getDecision($event)" (save)="submitAContent($event, 'Decision')"
            [mergeFields]="fusions" [showHidde]="true"
            [font]="globalElements?.configApp?.delibConfig?.defaultMiseEnFormeParams"></super-richedit>
        </ng-template>
      </p-accordionTab>
      <p-accordionTab (click)="onClick('Observations', 2)" [(selected)]="activeState[2]">
        <ng-template pTemplate="header">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              <h2 class="accordion-header-title" pTooltip="Observations">
                Observations
                <i class="icon-checkGreen green-icon"
                  *ngIf="contenuStaticRTFFilesPresents && contenuStaticRTFFilesPresents?.observations"></i>
              </h2>
            </div>
            <div class="accordion-icon">
              <i *ngIf="pointId" (click)="openFullScreen($event, 'Observations')"
                class="icon-fullscreen blue-icon middle-icon me-3"></i>
              <i pTooltip="Actualiser" tooltipPosition="bottom" (click)="reloadRTF($event, 'Observations', 2)"
                class="far fa-redo-alt blue-icon middle-icon">
              </i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <super-richedit [lang]="languageRichEdit" (click)="handleClick($event)" #document_editor_observation
            (getRtf)="getObservations($event)" (save)="submitAContent($event, 'Observations')" [mergeFields]="fusions"
            [showHidde]="true"
            [font]="globalElements?.configApp?.delibConfig?.defaultMiseEnFormeParams"></super-richedit>
        </ng-template>
      </p-accordionTab>
      <p-accordionTab (click)="onClick('ComplementDeDeliberation', 3)" [(selected)]="activeState[3]">
        <ng-template pTemplate="header">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              <h2 class="accordion-header-title" pTooltip="Complément de délibération">
                Complément de délibération
                <i class="icon-checkGreen green-icon" *ngIf="
                      contenuStaticRTFFilesPresents && contenuStaticRTFFilesPresents.complementDeDeliberation
                    "></i>
              </h2>
            </div>
            <div class="accordion-icon">
              <i *ngIf="pointId" (click)="openFullScreen($event, 'ComplementDeDeliberation')"
                class="icon-fullscreen blue-icon middle-icon me-3"></i>
              <i pTooltip="Actualiser" tooltipPosition="bottom" (click)="reloadRTF($event, 'NotesDeSynthese', 3)"
                class="far fa-redo-alt blue-icon middle-icon">
              </i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <super-richedit [lang]="languageRichEdit" (click)="handleClick($event)"
            #document_editor_complementDeDeliberation (getRtf)="getComplement($event)"
            (save)="submitAContent($event, 'ComplementDeDeliberation')" [mergeFields]="fusions" [showHidde]="true"
            [font]="globalElements?.configApp?.delibConfig?.defaultMiseEnFormeParams"></super-richedit>
        </ng-template>
      </p-accordionTab>
      <p-accordionTab (click)="onClick('NotesDeSynthese', 4)" *ngIf="config?.delibConfig?.isiDelibeCitoyensEnabled"
        [(selected)]="activeState[4]">
        <ng-template pTemplate="header">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              <h2 class="accordion-header-title" pTooltip="Notes de synthèse">
                Notes de synthèse
                <i class="icon-checkGreen green-icon"
                  *ngIf="contenuStaticRTFFilesPresents && contenuStaticRTFFilesPresents?.notesDeSynthese"></i>
              </h2>
            </div>
            <div class="accordion-icon">
              <i *ngIf="pointId" (click)="openFullScreen($event, 'NotesDeSynthese')"
                class="icon-fullscreen blue-icon middle-icon me-3"></i>
              <i pTooltip="Actualiser" tooltipPosition="bottom"
                (click)="reloadRTF($event, 'ComplementDeDeliberation', 4)"
                class="far fa-redo-alt blue-icon middle-icon">
              </i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <super-richedit [lang]="languageRichEdit" (click)="handleClick($event)" #document_editor_notesDeSynthese
            (getRtf)="getNotes($event)" (save)="submitAContent($event, 'NotesDeSynthèse')" [mergeFields]="fusions"
            [showHidde]="true"
            [font]="globalElements?.configApp?.delibConfig?.defaultMiseEnFormeParams"></super-richedit>
        </ng-template>
      </p-accordionTab>
    </p-accordion>
    <ng-template #isLoading>
      <div class="row h-100">
        <div class="col-md-12 d-flex justify-content-center align-items-center">
          <img src="./assets/img/loupe-loader.gif" />
        </div>
      </div>
    </ng-template>
  </section>
</div>